import { TikTikVideoEmbedData, TikTokEmbed } from 'src/types/domain';
import { toCamelCaseDeep } from 'src/utils/transform';
import * as Schema from './schema';

export default class TiktokVideoApiClass {
  private async api<T>(url: string): Promise<T> {
    const HOST = 'https://www.tiktok.com';

    return fetch(`${HOST}/${url}`).then(response => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json() as Promise<T>;
    });
  }

  public async getEmbedData(params: Schema.TiktokVideoEmbedDataRequest): Promise<TikTokEmbed> {
    const response = await this.api<Schema.TiktokVideoEmbedDataResponse>(
      `oembed?url=${params?.url}`,
    );
    return toCamelCaseDeep(response);
  }

  public async getVideoEmbedData(url: string): Promise<TikTikVideoEmbedData> {
    const response = await this.api<Schema.TiktokVideoEmbedDataResponse>(`oembed?url=${url}`);
    return toCamelCaseDeep(response);
  }
}

export const TiktokVideoApi = new TiktokVideoApiClass();
